import React, { useState } from "react";
import LeavePage from "../leavereport/LeavePage";
import { getCurrentUser } from "../../share/getProfile";
import { Tabs } from "antd";
import { PieChartOutlined, SolutionOutlined } from "@ant-design/icons"; // Import icons
import AttendanceQRCode from "../attendance/AttendanceQRcodePage";
import LettersPage from "../letter/LettersPage";
const { TabPane } = Tabs; // Correct destructuring of TabPane from Tabs

export default function UserLeave() {
  const getUser = getCurrentUser();

  return (
    <div>
      <Tabs defaultActiveKey="1">
        <TabPane
          tab="ការគ្រប់គ្រងច្បាប់​ របស់បុគ្គលិក"
          key="2"
          icon={<PieChartOutlined />}
        >
          <LeavePage
            getUser={getUser.fullname}
            txtSearchVisable={true}
            getIDnumber={getUser.idnumber}
            monthlyReport={1}
          />
        </TabPane>
        <TabPane tab="វត្តមានរបស់បុគ្គលិក" key="3" icon={<SolutionOutlined />}>
          <AttendanceQRCode
            filter_id_dept={true}
            GetUserName={getUser.username}
            GetIdnumber={getUser.user_id}
            txtSearchVisable={true}
            btn_add={true}
            hideOTTab={true}
          />
        </TabPane>
        <TabPane tab="បេសកម្មបុគ្គលិក" key="4" icon={<SolutionOutlined />}>
          <LettersPage
            btn_add_disable={true}
            btn_edit_disable={true}
            btn_delete_disable={true}
            btn_print_disable={false}
            option_filter={" "}
            GetUserName={getUser.username}
            GetIdnumber={getUser.idnumber}
          />
        </TabPane>
        <TabPane
          tab="ពាក្យស្នើបញ្ជាបេសកកម្ម"
          key="5"
          icon={<SolutionOutlined />}
        >
          <LettersPage
            btn_add_disable={false}
            btn_edit_disable={false}
            btn_delete_disable={false}
            btn_print_disable={false}
            show_user_requests_div={false}
            user_requests_title={"ឈ្មោះមន្ត្រីស្នើបញ្ជាបេសកកម្ម"}
            option_filter={"requestmission"}
            res_url={"lettersmissionrequests"}
            GetUserName={getUser.username}
            GetIdnumber={getUser.idnumber}
            user_requests_print_disable={true}
            prepare_by_title={"បេសកកម្មយោង​ ៖ "}
            car_support_by={"ថវិការដ្ឋ"}
            car_lettertype={"លិខិតឧទ្ទេសនាមបេសកកម្ម"}
            type_letter_in_out={"ចេញ"}
          />
        </TabPane>
      </Tabs>
    </div>
  );
}
